import React, { useState } from "react";
import Tooltip from "@mui/material/Tooltip";
import editIcons from "../../../../../assets/icons/editIcons.svg";
import addREC from "../../../../../assets/icons/addREC.svg";
import CompanyDashboardInitiativeDrawerSideBarDescriptionPopup from "./company-dashboard-initiative-drawer-side-bar-description-popup";
import "./company-dashboard-initiative-drawer-side-bar.scss";
import { OverlayScrollbarsComponent } from "overlayscrollbars-react";

const CompanyDashboardInitiativeDrawerSideBarDescription: any = (
  props: any,
) => {// NOSONAR
  const {
    description,
    setDescription,
    initiativeIdTooltip,
    initiativeId,
    handleCreateInitiative,
    payloadData,
    canEdit,
    canWrite,
    initiativeDataPermissions,
  } = props;
  const [isShowEditDescription, setIsShowEditDescription] = useState(false);

  let actionIcon: React.ReactNode = null;
  if (initiativeId) {
    if (canEdit && initiativeDataPermissions) {
      actionIcon = <img src={editIcons} alt="edit" />;
    } else if (canWrite && initiativeDataPermissions) {
      actionIcon = <img src={addREC} alt="add" />;
    }
  } else if (canWrite && initiativeDataPermissions) {
    actionIcon = <img src={addREC} alt="add" />;
  } else if (canEdit && initiativeDataPermissions) {
    actionIcon = <img src={editIcons} alt="edit" />;
  }

  return (
    <>
      <div className="company-dashboard-initiative-drawer-side-bar-content-header">
        <div>Description</div>
        <Tooltip title={initiativeIdTooltip}>
          <button
            className="company-dashboard-initiative-drawer-side-bar-content-header-edit-icon"
            onClick={() => {
              if (initiativeId && canEdit && initiativeDataPermissions)
                setIsShowEditDescription(true);
            }}
            style={{
              cursor:
                !initiativeId || (!canEdit && !canWrite)
                  ? "not-allowed"
                  : "pointer",
            }}
          >
            {actionIcon}
          </button>
        </Tooltip>
      </div>
      <div className="company-dashboard-initiative-drawer-side-bar-content-description">
        <OverlayScrollbarsComponent
          options={{
            scrollbars: {
              theme: "os-theme-dark",
              autoHide: "scroll",
              autoHideDelay: 400,
            },
          }}
          style={{
            maxHeight: "150px", // fixed height
            overflowY: "auto", // vertical scroll
            overflowX: "hidden", // prevent horizontal scroll
            whiteSpace: "normal", // wrap text
            wordWrap: "break-word",
            wordBreak: "break-word",
            paddingRight: "10px", // space for scrollbar
          }}
          className="company-dashboard-initiative-drawer-side-bar-content-description-content"
        >
          {description || (
            <div className="company-dashboard-initiative-drawer-side-bar-content-description-no">
              <div className="company-dashboard-initiative-drawer-side-bar-content-description-no-text ">
                No description has been added yet.
              </div>
              {canWrite && initiativeDataPermissions && (
                <Tooltip title={initiativeIdTooltip}>
                  <button
                    className="company-dashboard-initiative-drawer-side-bar-content-description-no-button"
                    onClick={() =>
                      initiativeId ? setIsShowEditDescription(true) : null
                    }
                    style={{ cursor: initiativeId ? "pointer" : "not-allowed" }}
                    disabled={!canWrite}
                  >
                    Add Description
                  </button>
                </Tooltip>
              )}
            </div>
          )}
        </OverlayScrollbarsComponent>
      </div>
      <CompanyDashboardInitiativeDrawerSideBarDescriptionPopup
        isShowEditDescription={isShowEditDescription}
        setIsShowEditDescription={setIsShowEditDescription}
        description={description}
        setDescription={setDescription}
        handleCreateInitiative={handleCreateInitiative}
        payloadData={payloadData}
      />
    </>
  );
};

export default CompanyDashboardInitiativeDrawerSideBarDescription;
